import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Timeline from "@/components/Timeline";

import Image from "next/image";
import Link from "next/link";
import AOS from "aos";

import story02 from "@/public/static/images/bg_story_02.png";
import story04 from "@/public/static/images/bg_story_04.png";
import story05 from "@/public/static/images/bg_story_05.png";
import story06 from "@/public/static/images/bg_story_06.png";
import story07 from "@/public/static/images/bg_story_07.png";

import ourstory01 from "@/public/static/images/our_story_01.png";
import ourstory02 from "@/public/static/images/our_story_02.png";
import ourstory03 from "@/public/static/images/our_story_03.png";
import ourstory04 from "@/public/static/images/our_story_04.png";
import ourstory05 from "@/public/static/images/our_story_05.png";
import ourstory06 from "@/public/static/images/our_story_06.png";
import ourstory07 from "@/public/static/images/our_story_07.png";

import logotory from "@/public/static/images/logo_story.png";

import bg from "@/public/static/images/bg_story-p.png";

const Overview = () => {
  AOS.init({
    offset: 200,
    duration: 600,
    easing: "ease-in-out-sine",
    delay: 200,
    mirror: true,
  });

  return (
    <div className="wrapper story-page" id="smooth-wrapper">
      <Header />

      <section className="story1 h80">
        <div className="section gray-content">
          <div className="fixed">
            <div className="row">
              <div className="col-12 text-center heading-ban_story">
                <h1 className="lh-1 fw-bold">
                  Your one-stop solution partner in Thailand,
                  <br />
                  The hub of south-east Asia.
                </h1>
                <h2 className="mb-3">
                  As one of the regional headquarters of ITP Inc.,
                  <br />
                  ITP ASIA CO., LTD. brings one-stop solution services
                  <br />
                  to cover Thailand and South East Asian countries business.
                </h2>
              </div>
            </div>
            <div className="field">
              <p>Let’s get to know us!</p>
              <div className="scroll"></div>
            </div>
          </div>
        </div>
      </section>
      <section className="story1">
        <div className="section black-content">
          <div className="fixed">
            <div className="overviwe-bg_inner">
              <div className="overviwe-inner_img">
                <Image
                  loading="lazy"
                  src={story02}
                  alt="Company Overview"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="overviwe-inner_detail">
              <div className="overviwe_detail">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Company Name</p>
                </div>
                <div className="overviwe_detail-content">
                  <p className="mb-1">ITP ASIA CO.,LTD.</p>
                </div>
              </div>
              <div className="overviwe_detail">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Established</p>
                </div>
                <div className="overviwe_detail-content">
                  <p className="mb-1">May 1999</p>
                </div>
              </div>
              <div className="overviwe_detail mb-4">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Representative</p>
                </div>
                <div className="overviwe_detail-content">
                  <p className="mb-1">Yoshikazu Koyama</p>
                  <p className="mb-1">
                    Representative Executive Officer, President
                  </p>
                </div>
              </div>

              <div className="overviwe_detail">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Company Address</p>
                </div>
              </div>
              <div className="overviwe_detail mb-3">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Head Office</p>
                </div>
                <div className="overviwe_detail-content">
                  <p className="mb-1">
                    589/160 Central City Tower, Room OF3004, 30th Floor, <br />
                    Debaratana Road, Bangna Nuea, Bangna, <br />
                    Bangkok 10260
                  </p>
                  <p className="mb-1">
                    <span>TEL:</span> 0-2745-6050 Ext. 0 (Thai)
                  </p>
                  <p className="mb-1">Ext. 701 (Japanese)</p>
                  <p className="mb-1">
                    <span>FAX:</span> 0-2740-6055
                  </p>
                </div>
              </div>
              <div className="overviwe_detail mb-3">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Samrong Office</p>
                </div>
                <div className="overviwe_detail-content">
                  <p className="mb-1">
                    186/1 Mu 1. Old Railway road, Samrong Tai,
                    <br />
                    Phrapradaeng, Samutprakarn 10130
                  </p>
                </div>
              </div>
              <div className="overviwe_detail mb-3">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Number of Employees</p>
                </div>
                <div className="overviwe_detail-content">
                  <p className="mb-1">66 (As of January 1, 2024)</p>
                </div>
              </div>
              <div className="overviwe_detail mb-3">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Parent Company </p>
                </div>
                <div className="overviwe_detail-content">
                  <p className="mb-1">
                    ITP Inc.
                    <br />
                    [Headquarters] Ogawa Nishiiru, Marutamachi-Dori, <br />
                    Nakagyo-ku, Kyoto, 604-0087 Japan
                    <br />
                  </p>
                  <p className="mb-1">
                    <span>TEL:</span> +81(0)-75-211-9111
                  </p>
                </div>
              </div>
              <div className="overviwe_detail mb-3">
                <div className="overviwe_detail-subject">
                  <p className="mb-1">Group Company </p>
                </div>
                <div className="overviwe_detail-content">
                  <p className="mb-1">CYBER-ITP (Thailand) Co., Ltd. (CIT)</p>
                  <p className="mb-1">ITP MYANMAR Co., Ltd.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="story">
        <section className="story2">
          <div className="container-fluid">
            <div className="description panel gray-content">
              <div className="img-wrapper_inner">
                <div className="row">
                  <div className="col-12 text-center heading-horizontal_story">
                    <h1 className="mb-3">
                      With our sight always set towards the future of
                      information services,
                      <br />
                      <span className="fw-bold">
                        we continue to provide innovative solutions
                      </span>
                      <br />
                      in line with the growth of our customers.
                    </h1>
                  </div>
                </div>
                <Image
                  loading="lazy"
                  src={story04}
                  alt="Company Overview"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>

            <section className="panel black-content">
              <div className="img-wrapper_inner">
                <div className="row">
                  <div className="col-12 text-center heading-horizontal_story">
                    <h1 className="t-white mb-3">
                      With our sight always set towards the future of
                      information services,
                      <br />
                      <span className="fw-bold">
                        we continue to provide innovative solutions
                      </span>
                      <br />
                      in line with the growth of our customers.
                    </h1>
                  </div>
                </div>
                <Image
                  loading="lazy"
                  src={story05}
                  alt="Company Overview"
                  className="img-fluid mx-auto"
                />
              </div>
            </section>
            <section className="panel gray-content">
              <div className="img-wrapper_inner">
                <div className="row">
                  <div className="col-12 text-center heading-horizontal_story">
                    <h1 className="mb-3">
                      With our sight always set towards the future of
                      information services,
                      <br />
                      <span className="fw-bold">
                        we continue to provide innovative solutions
                      </span>
                      <br />
                      in line with the growth of our customers.
                    </h1>
                  </div>
                </div>
                <Image
                  loading="lazy"
                  src={story06}
                  alt="Company Overview"
                  className="img-fluid mx-auto"
                />
              </div>
            </section>
          </div>
        </section>
      </div>

      <section className="story4">
        <div className="sv_content black-content">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center ev-heading-ov_bl">
                <h1 className="fw-bolder t-white lh-1">OUR TEAM</h1>
                <hr />
                <hr className="line-2" />
              </div>
              <div className="col-12 story4-heading">
                <h1 className="fw-bold t-white">MARKETING & SALES</h1>
              </div>
              <div className="col-12 story4-content">
                <p className="t-white mb-5">
                  With their exceptional skills, customer-centric approach, and
                  unwavering commitment, they are the backbone of our sales
                  operations, and also the driving force behind our business
                  growth and success.
                </p>
              </div>
              <div className="col-12 col-lg-6 story4-content">
                <div className="h-100">
                  <Image
                    loading="lazy"
                    src={ourstory01}
                    alt="Company Overview"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6 story4-content">
                <div className="h-100 d-flex justify-content-end align-items-center">
                  <ul className="t-white">
                    <li>• Marketing & Sales</li>
                    <li>• Automotive Business Support</li>
                    <li>• Integrated Marketing Communication</li>
                    <li>• Sales Promotion Commerce</li>
                    <li>• Customer Service</li>
                    <li>• Event Planning</li>
                    <li>• Inbound Business</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sv_content gray-content">
          <div className="container">
            <div className="row">
              <div className="col-12 story4-heading">
                <h1 className="fw-bold">
                  PROCUREMENT &<br />
                  LOGISTIC OPERATION
                </h1>
              </div>
              <div className="col-12 col-lg-6 story4-content">
                <p className="mb-4">
                  Our Procurement & Logistic Operation team is an integral part
                  of our company's success, tirelessly working to quality
                  assure, monitor, and supply products to our esteemed
                  automotive clients with unwavering dedication.{" "}
                </p>

                <p className="mb-4">
                  Their exceptional expertise in procurement, inventory
                  management, and logistics ensures that our clients' needs are
                  met promptly and efficiently.{" "}
                </p>

                <p className="mb-4">
                  Their commitment to excellence and exceptional problem-solving
                  abilities enable us to overcome challenges and maintain a
                  smooth and uninterrupted flow of operations.
                </p>
              </div>
              <div className="col-12 col-lg-6 story4-content">
                <Image
                  loading="lazy"
                  src={ourstory02}
                  alt="Company Overview"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="sv_content black-content">
          <div className="container">
            <div className="row">
              <div className="col-12 story4-heading">
                <h1 className="fw-bold t-white">
                  LOCALIZATION &<br />
                  INNOVATION CENTER
                </h1>
              </div>
              <div className="col-12 story4-content">
                <p className="t-white mb-5">
                  LIC team is a pivotal force within our organization. With a
                  forward-thinking mindset and a relentless pursuit of
                  innovation, the LIC team consistently exceeds expectations
                  with their products and innovation, which lead them to be
                  another important force that drives our company's success.
                </p>
              </div>

              <div className="col-12 col-lg-6 story4-content">
                <div className="h-100 d-flex justify-content-center align-items-center">
                  <ul className="t-white">
                    <li>• Translation</li>
                    <li>• DTP & QA</li>
                    <li>• Language Engineer</li>
                    <li>• Software Development</li>
                    <li>• Digital Marketing</li>
                    <li>• Graphic Design</li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-lg-6 story4-content">
                <div className="h-100">
                  <Image
                    loading="lazy"
                    src={ourstory03}
                    alt="Company Overview"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sv_content gray-content">
          <div className="container">
            <div className="row">
              <div className="col-12 story4-heading">
                <h1 className="fw-bold">BACK OFFICE</h1>
              </div>
              <div className="col-12 story4-content">
                <p className="mb-5">
                  Our back office serves as the backbone of our organization,
                  providing invaluable support to ensure that all other teams
                  can fully focus on their core tasks and perform their best.
                  Their commitment to employee well-being create a truly solid
                  foundation for our entire organization.
                </p>
              </div>
              <div className="col-12 col-lg-6 story4-content">
                <div className="h-100">
                  <Image
                    loading="lazy"
                    src={ourstory04}
                    alt="Company Overview"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6 story4-content">
                <div className="h-100 d-flex justify-content-end align-items-center">
                  <ul className="">
                    <li>• Corporate Administration</li>
                    <li>• Accounting & Finance</li>
                    <li>• Human Resource & Development</li>
                    <li>• Quality Assurance & ISO</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="story5">
        <div className="sv_content black-content">
          <div className="container">
            <div className="row">
              <div className="col-12 t-white text-center philosophy">
                <Image
                  loading="lazy"
                  src={logotory}
                  alt="Company Overview"
                  className="img-fluid mx-auto me-3"
                />
                philosophy
              </div>
              <div className="col-12 t-white text-center text-itp_color">
                <h1>
                  <span className="t-pink">I</span>DEAS{" "}
                  <span className="brake">•</span>{" "}
                  <span className="t-darkblue">T</span>ECHNOLOGY{" "}
                  <span className="brake">•</span>{" "}
                  <span className="t-orange">P</span>EOPLE
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row row-cols-1 row-cols-lg-3">
            <div className="col gray-content c-story_5">
              <div className="card h-100">
                <div className="card-body text-center">
                  <Image
                    loading="lazy"
                    src={ourstory05}
                    alt="Company Overview"
                    className="img-fluid mx-auto"
                  />
                  <h3>
                    <span className="t-pink">I</span>DEAS
                  </h3>
                  <p className="">
                    We communicate closely with our customers to identify the
                    true nature of problems and create ideas that become the
                    keys towards finding solutions.
                  </p>
                </div>
              </div>
            </div>
            <div className="col black-content c-story_5">
              <div className="card h-100">
                <div className="card-body text-center">
                  <Image
                    loading="lazy"
                    src={ourstory06}
                    alt="Company Overview"
                    className="img-fluid mx-auto"
                  />
                  <h3 className="t-white">
                    <span className="t-darkblue">T</span>ECHNOLOGY
                  </h3>
                  <p className="t-white">
                    In order to optimally realize the ideas we have created, we
                    devote ourselves to the daily study of technology and use
                    our advanced skills to shape information.
                  </p>
                </div>
              </div>
            </div>
            <div className="col gray-content c-story_5">
              <div className="card h-100">
                <div className="card-body text-center">
                  <Image
                    loading="lazy"
                    src={ourstory07}
                    alt="Company Overview"
                    className="img-fluid mx-auto"
                  />
                  <h3>
                    <span className="t-orange">P</span>EOPLE
                  </h3>
                  <p className="">
                    Each of our employees demonstrate their abilities and build
                    positive relationships between people to make contributions
                    to only our customers, but a wide range of people in
                    society.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Timeline />

      <Footer />
    </div>
  );
};

export default Overview;
